module.exports = " <div class=btn-group data-toggle=buttons> <slot></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/_vue-html-loader@1.2.4@vue-html-loader!./~/_vue-loader@8.3.1@vue-loader/lib/selector.js?type=template&index=0!./bootsets/components/vue-strap/radioGroup.vue
// module id = 267
// module chunks = 0